var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "w-100 user-modal-register-account-created-view px-2" },
    [
      _c("div", { staticClass: "mb-5 text-center" }, [
        _c("p", { staticClass: "font-weight-bold font-size-200" }, [
          _vm._v(_vm._s(_vm.titleText)),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "mb-0 font-size-125" }, [
          _vm._v(_vm._s(_vm.titleSubText)),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "mb-5 d-flex justify-content-center" }, [
        _c(
          "div",
          {
            staticClass: "circle-loader",
            class: { "load-complete": _vm.finishLoader },
          },
          [
            _c("div", {
              staticClass: "checkmark draw",
              class: { "d-block": _vm.finishLoader },
            }),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "mb-5 text-center" }, [
        _c("p", {
          staticClass: "mb-5 font-size-125",
          domProps: { innerHTML: _vm._s(_vm.descriptionText) },
        }),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "d-flex justify-content-between flex-wrap",
          staticStyle: { gap: "1rem" },
        },
        [
          _c("ButtonWithLoadingState", {
            staticClass:
              "btn btn-warning btn-lg font-weight-bold text-uppercase rounded flex-grow-1",
            staticStyle: { "flex-basis": "50%" },
            attrs: {
              "data-user-modal-button-submit-premium": "",
              icon: "fa fa-arrow-right lh-1",
              text: _vm.getPremium,
              "is-state-loading": _vm.isSubmitting,
              "show-icon-after-text": true,
            },
            on: {
              click: function ($event) {
                $event.stopPropagation()
                $event.preventDefault()
                return _vm.doContinuePremium.apply(null, arguments)
              },
            },
          }),
          _vm._v(" "),
          _c("ButtonWithLoadingState", {
            staticClass:
              "btn btn-success btn-lg font-weight-bold text-uppercase rounded flex-grow-1",
            attrs: {
              "data-user-modal-button-submit-free": "",
              icon: "fa fa-arrow-right lh-1",
              text: _vm.continueText,
              "is-state-loading": _vm.isSubmitting,
              "show-icon-after-text": true,
            },
            on: {
              click: function ($event) {
                $event.stopPropagation()
                $event.preventDefault()
                return _vm.doContinueFree.apply(null, arguments)
              },
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }